import { FC } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

type NotFoundProps = {
  backRoute: string;
};

export const NotFound: FC<NotFoundProps> = ({ backRoute }) => {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-4">
          <FormattedMessage id="notFound.title" defaultMessage="404" />
        </h1>
        <p className="text-xl text-gray-600 mb-4">
          <FormattedMessage
            id="notFound.heading"
            defaultMessage="Page not found"
          />
        </p>
        <p className="text-gray-500 mb-6">
          <FormattedMessage
            id="notFound.description"
            defaultMessage="The page you're looking for doesn't exist or you don't have access to it."
          />
        </p>
        <button
          onClick={() => navigate(backRoute)}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          <FormattedMessage
            id="notFound.backButton"
            defaultMessage="Go back to cases"
          />
        </button>
      </div>
    </div>
  );
};
